import { useQuery } from '@tanstack/react-query';
import { meApi } from '@/lib/apiClient';
import { mapUser, type CurrentUser } from '@/types/user';

export const CURRENT_USER_KEY = ['me'] as const;

export function useCurrentUser() {
  return useQuery<CurrentUser>({
    queryKey: CURRENT_USER_KEY,
    queryFn: async () => mapUser(await meApi.getMe()),
    staleTime: 5 * 60 * 1000,
    retry: false,
  });
}
